/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Secure_FooterInputs */

const en_support_secure_footer = /** @type {(inputs: Support_Secure_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secure Encryption • Stripe Verified • Sovereign Support`)
};

const es_support_secure_footer = /** @type {(inputs: Support_Secure_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cifrado Seguro • Verificado por Stripe • Soporte Sovereign`)
};

const fr_support_secure_footer = /** @type {(inputs: Support_Secure_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiffrement Sécurisé • Vérifié par Stripe • Soutien Souverain`)
};

const de_support_secure_footer = /** @type {(inputs: Support_Secure_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sichere Verschlüsselung • Stripe verifiziert • Sovereign Support`)
};

const id_support_secure_footer = /** @type {(inputs: Support_Secure_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enkripsi Aman • Stripe Terverifikasi • Dukungan Sovereign`)
};

/** @type {(inputs: Support_Secure_FooterInputs) => LocalizedString} */
const ja_support_secure_footer = en_support_secure_footer;

/** @type {(inputs: Support_Secure_FooterInputs) => LocalizedString} */
const zh_support_secure_footer = en_support_secure_footer;

/** @type {(inputs: Support_Secure_FooterInputs) => LocalizedString} */
const ar_support_secure_footer = en_support_secure_footer;

/** @type {(inputs: Support_Secure_FooterInputs) => LocalizedString} */
const it_support_secure_footer = en_support_secure_footer;

/** @type {(inputs: Support_Secure_FooterInputs) => LocalizedString} */
const ru_support_secure_footer = en_support_secure_footer;

/** @type {(inputs: Support_Secure_FooterInputs) => LocalizedString} */
const pt_support_secure_footer = en_support_secure_footer;

/** @type {(inputs: Support_Secure_FooterInputs) => LocalizedString} */
const ko_support_secure_footer = en_support_secure_footer;

/**
* | output |
* | --- |
* | "Secure Encryption • Stripe Verified • Sovereign Support" |
*
* @param {Support_Secure_FooterInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const support_secure_footer = /** @type {((inputs?: Support_Secure_FooterInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Secure_FooterInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_support_secure_footer(inputs)
	if (locale === "es") return es_support_secure_footer(inputs)
	if (locale === "fr") return fr_support_secure_footer(inputs)
	if (locale === "de") return de_support_secure_footer(inputs)
	if (locale === "ja") return ja_support_secure_footer(inputs)
	if (locale === "zh") return zh_support_secure_footer(inputs)
	if (locale === "ar") return ar_support_secure_footer(inputs)
	if (locale === "id") return id_support_secure_footer(inputs)
	if (locale === "it") return it_support_secure_footer(inputs)
	if (locale === "ru") return ru_support_secure_footer(inputs)
	if (locale === "pt") return pt_support_secure_footer(inputs)
	return ko_support_secure_footer(inputs)
});